export const svgToBase64 = ({ icon }: { icon: string }): string => {
  return `data:image/svg+xml;charset=UTF-8;base64,${btoa(`${icon}`)}`;
};
